import linkRuleHover from '../../../../common/algorithms/link-rule-hover';

const custom = (params) => linkRuleHover(params);

export default custom;
